package io.horion.cv.utils

import androidx.compose.animation.core.animateIntAsState
import androidx.compose.animation.core.tween
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.silk.components.text.SpanText
import io.horion.cv.models.ExperienceLevel
import io.horion.cv.models.JobStatus
import io.horion.cv.models.JobType
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.px

@Composable
fun AnimatedCount(
    target: Int,
    durationMillis: Int = 1500,
    isMobile: Boolean = false
) {
    var countState by remember { mutableStateOf(0) }

    val animatedCount by animateIntAsState(
        targetValue = countState,
        animationSpec = tween(durationMillis = durationMillis)
    )

    LaunchedEffect(target) {
        countState = target
    }

    SpanText(
        text = animatedCount.toString(),

        modifier = Modifier
            .fontSize(if (isMobile) 40.px else 96.px)
            .fontFamily(INTER)
            .fontWeight(FontWeight.ExtraBold)
            .color(Colors.LighterBlue)
    )
}

fun JobType.label(): String {
    return when (this) {
        JobType.CDI -> "CDI"
        JobType.CDD -> "CDD"
        JobType.STAGE -> "Stage"
        JobType.FREELANCE -> "Freelance"
        JobType.INTERIM -> "Intérim"
        JobType.LEARNING -> "Alternance"
    }
}

fun JobStatus.label(): String {
    return when (this) {
        JobStatus.ACTIVE -> "ACTIVE"
        JobStatus.EXPIRED -> "EXPIRED"
        JobStatus.FILLED -> "FILLED"
    }
}
fun ExperienceLevel.label(): String{
    return when(this){
        ExperienceLevel.MID -> "MID"
        ExperienceLevel.JUNIOR -> "JUNIOR"
        ExperienceLevel.SENIOR -> "SENIOR"
        ExperienceLevel.EXPERT -> "EXPERT"
    }
}

fun String?.orDefault(default: String = "NON RENSEIGNÉ"): String {
    return if (this.isNullOrEmpty()) default else this
}
